var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-c-data-card-body__row"},[_c('div',{staticClass:"cf-c-data-card-body__label"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"cf-c-data-card-body__value",class:_vm.textColorStyles},[_vm._v(" "+_vm._s(_vm.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }